"use client";

import { useAppDispatch, useAppStore } from "@/redux/hooks";
import { setHomeData } from "@/components/PageHome/redux/slice";

const useSyncHomeData = ({ homeInfo }) => {
  const dispatch = useAppDispatch();
  const store: any = useAppStore();

  if (!store?.getState()?.home?.homeData) {
    dispatch(setHomeData(homeInfo));
  }
};

export { useSyncHomeData };
